import styled from "styled-components/macro";

export const InfoContainer = styled.div`
  color: #fff;
  background: ${({ lightBg }) => (lightBg ? "#f9f9f9" : "#ede6b9")};

  @media screen and (max-width: 768px) {
    padding: 100px 0;
  }
`;

export const InfoWrapper = styled.div`
  display: grid;
  z-index: 1;
  height: 100vh;
  width: 100%;
  /* max-width: 1100px;
  margin-right: auto;
  margin-left: auto; */
  padding: 0 24px;
  /* justify-content: center; */

  @media screen and (max-width: 480px) {
    height: 100%;
  }
`;

export const InfoRow = styled.div`
  display: grid;
  grid-auto-columns: minmax(auto, 1fr);
  align-items: center;
  grid-template-areas: ${({ imgStart }) =>
    imgStart ? `'col2 col1'` : `'col1 col2' `};

  @media screen and (max-width: 768px) {
    grid-template-areas: ${({ imgStart }) =>
      imgStart ? `'col1' 'col2'` : `'col1 col1' 'col2 col2'`};
  }
`;

export const Column1 = styled.div`
  margin-bottom: 15px;
  padding: 0 15px;
  grid-area: col1;
`;
export const Column2 = styled.div`
  margin: 0 auto;
  margin-bottom: 15px;
  padding: 0 15px;
  grid-area: col2;
`;

export const TextWrapper = styled.div`
  /* max-width: 540px; */
  padding-top: 0;
  padding-bottom: 60px;
`;

export const Heading = styled.h1`
  margin-bottom: 24px;
  font-size: 48px;
  line-height: 1.1;
  font-weight: 600;
  color: ${({ lightText }) => (lightText ? "#f7f8fa" : "#010606")};

  @media screen and (max-width: 480px) {
    font-size: 32px;
  }
`;
export const Subtitle = styled.p`
  /* max-width: 440px; */
  overflow: hidden;
  text-align: justify;
  margin-bottom: 35px;
  font-size: 18px;
  line-height: 24px;
  color: ${({ darkText }) => (darkText ? "#010606" : "#fff")};
`;

export const ImgWrap = styled.div`
  max-width: 444px;
  height: 100%;
`;
export const Img = styled.img`
  width: 100%;
  height: 100%;
  margin: 0 0 18px 0;
  padding-right: 0;
`;

export const ActivityListContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  color: #000;
  @media screen and (max-width: 480px) {
    max-width: 250px;
  }
`;
export const ActivityListWrapper = styled.div`
  flex: 1;
`;

export const ActivityListHeading = styled.h2``;

export const ActivityList = styled.ul`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  list-style: none;
  padding: 20px 0 20px 0;
`;
export const ActivityListItem = styled.li`
  display: flex;
  align-items: center;
  margin: 5px 0 5px 0;
`;

export const ActivityListItemSpan = styled.span`
  font-size: 25px;
  margin-right: 10px;
`;
